import React, { useState } from 'react';
import OrdersTableSkeleton from './OrdersTableSkeleton';

const OrdersTable = ({ buyOrders, sellOrders }) => {
  const [activeTab, setActiveTab] = useState('buy');
  const [showAll, setShowAll] = useState(false);

  if (!buyOrders || !sellOrders) {
    return <OrdersTableSkeleton />;
  }

  const renderTable = (data, title) => (
    <div className="pb-4 pr-2 pl-2">
      <h3 className="text-md font-bold text-center mb-2 hidden md:block">{title}</h3>
      <table className="min-w-full text-sm text-gray-900">
        <thead className="text-xs text-gray-700 text-right uppercase bg-gray-50">
          <tr>
            <th scope="col" className="py-3 px-6">Amount</th>
            <th scope="col" className="py-3 px-6">Price</th>
            <th scope="col" className="py-3 px-6">Value</th>
            <th scope="col" className="py-3 px-6 hidden lg:block text-center">Updated</th>
          </tr>
        </thead>
        <tbody>
          {data.slice(0, showAll ? data.length : 7).map(order => (
            <tr key={order.id} style={{ backgroundColor: order.orderType === "Sell" ? 'rgba(238, 195, 195, 0.3)' : 'rgba(194, 245, 225, 0.3)' }} className="border-b text-right">
              <td className="py-4 px-6">
                {"Ƚ" + parseFloat(order.amount).toLocaleString('en-US', { maximumFractionDigits: 0 })}
              </td>
              <td className="py-4 px-6">
                ${parseFloat(order.price).toFixed(5)}
              </td>
              <td className="py-4 px-6">
                ${(parseFloat(order.price) * parseFloat(order.amount)).toLocaleString('en-US', { maximumFractionDigits: 0 })}
              </td>
              <td className="py-4 px-6 hidden lg:block text-center">
                {new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(order.updatedAt))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      <div className="flex flex-col md:flex-row w-full">
        <div className="flex w-full justify-center md:hidden pb-2">
          <button className={`p-2 ${activeTab === 'buy' ? 'font-bold border-b border-[#DE2F32]' : ''} px-6`} onClick={() => setActiveTab('buy')}>Buy Orders</button>
          <button className={`p-2 ${activeTab === 'sell' ? 'font-bold border-b border-[#DE2F32]' : ''} px-6`} onClick={() => setActiveTab('sell')}>Sell Orders</button>
        </div>
        <div className="w-full">
          {activeTab === 'buy' ? renderTable(buyOrders, 'Buy Orders') : renderTable(sellOrders, 'Sell Orders')}
        </div>
        <div className="w-full hidden md:block">
          {activeTab === 'buy' ? renderTable(sellOrders, 'Sell Orders') : null}
        </div>
      </div>
      <div className="text-center my-4">
        <button
          onClick={() => setShowAll(!showAll)}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          {showAll ? 'Show Less' : 'Show More'}
        </button>
      </div>
    </>
  );
};

export default OrdersTable;